import { Component, Input, forwardRef, OnInit } from '@angular/core';

import { BooleanRadioFieldModel } from '../../../models/boolean-radio-field.model';
import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';

@Component({
    selector: 'agpr-boolean-radio-field',
    templateUrl: './boolean-radio-field.component.html',
    styleUrls: ['./boolean-radio-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => BooleanRadioFieldComponent)
        }
    ],
    standalone: false
})
export class BooleanRadioFieldComponent extends AbstractFormFieldComponent implements OnInit {
    @Input() declare field: BooleanRadioFieldModel;
    showBooleanRadio: boolean = true;

    ngOnInit(): void {
        this.showBooleanRadio = this.field.appearCondition(this.block?.displayElement);
    }

    onRadioChanged(): void {
        this.changes.emit(this.value);
    }
}
